import Vue from 'vue'
import Vuex from 'vuex'
import { Auth } from '@/api'
import router from '@/router'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: state => ({ userInfo: state.userInfo })
})

export default new Vuex.Store({
  state: {
    userInfo: {}
  },
  mutations: {
    setUserInfo(state, payload) {
      state.userInfo = payload
    },
    clearUserInfo(state) {
      state.userInfo = {}
      window.localStorage.removeItem('token')
      router.push({ name: 'Login' })
    }
  },
  actions: {
    fetchUserInfo({ commit }) {
      return Auth.me().then(res => {
        commit('setUserInfo', res.data)
      })
    },
    logout({ commit }) {
      return Auth.logout().then(() => {
        commit('clearUserInfo')
      })
    }
  },
  modules: {},
  plugins: [vuexLocal.plugin]
})
